import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconMall: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} ariaLabel="mall, store, shop, business" maskId="round-filled-radius-1-stroke-1.5-IconMall"><path fillRule="evenodd" clipRule="evenodd" d="M2 5.75C2 4.7835 2.7835 4 3.75 4H20.25C21.2165 4 22 4.7835 22 5.75V18.25C22 19.2165 21.2165 20 20.25 20H3.75C2.7835 20 2 19.2165 2 18.25V5.75ZM16 18.5V11.75C16 11.3358 15.6642 11 15.25 11H12.75V18.5H16ZM11.25 18.5V11H8.75C8.33579 11 8 11.3358 8 11.75V18.5H11.25Z" fill="currentColor"/></CentralIconBase>;
});

export default IconMall;
